<template>
    <div class="home_page">
        <div class="search_form focus">
            <form @submit.prevent="submit" v-if="!employeeSelected">
                <div class="icon"></div>
                <input id="institutions_search_input" @change="submit" type="search" v-model="search">
                <div class="icon_close" @click="handleClickCloseBtn"></div>
            </form>

            <div class="search_result">
                <div class="items_list white">
                    <!--INSTITUTIONS SEARCH RESULT-->
                    <div class="item item-header" v-if="institutions.length > 0">
                        <span class="icon-search"></span>
                        <span class="text"><strong>施設: {{institutions.length}}件</strong></span>
                    </div>
                    <div class="item" v-for="item in institutions" :key="item.institution_code"
                         @click="handleClickInstitution(item)">
                        <span class="text">{{item.official_name_kanji}}</span>
                    </div>

                    <!--EMPLOYEES SEARCH RESULT-->
                    <div class="item item-header" v-if="countEmployees > 0">
                        <span class="icon-search"></span>
                        <span class="text"><strong>担当者: {{countEmployees}}件</strong></span>
                    </div>
                    <div v-if="item.employee_code !== user.employee_code" class="item" v-for="item in employees" :key="item.institution_code"
                         @click="handleClickEmployee(item)">
                        <span class="text">{{item.name_kanji}}</span>
                    </div>
                </div>

                <div class="items_list white employee_selected_institutions" v-if="employeeSelected">
                    <div class="item">
                        <span class="text"><strong>{{employeeSelected.name_kanji}}</strong></span>
                    </div>
                    <div class="item" v-for="item in employeeSelected.institutions" :key="item.institution_code"
                         @click="handleClickInstitution(item)"
                    >
                        <span class="text">{{item.official_name_kanji}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import InstitutionApi from '@/api/institution'

  export default {
    data () {
      return {
        search: '',
        institutions: [],
        employees: [],
        employeeSelected: null
      }
    },
    computed: {
      user: function () {
        return this.$auth.user()
      },
      countEmployees: function () {
        let count = 0
        this.employees.map(employee => {
          if (employee.employee_code !== this.$auth.user().employee_code) count++
        })
        return count
      }
    },
    methods: {
      ...mapActions({
        setNavigatorLinks: 'navigator/setLinks',
        setNavigatorTitle: 'navigator/setTitle',
        setLinks: 'navigator/setLinks',
        setFineplay: 'navigator/setFineplay'
      }),
      handleClickInstitution (institution) {
        this.$router.push({name: 'institutions.show', params: {institutionCode: institution.institution_code}})
      },
      handleClickEmployee (employee) {
        this.setLinks([{title: `${employee.display_name}`, route: {name: 'home'}}])
        this.employeeSelected = employee
        this.employees = []
        this.institutions = []
        document.getElementsByClassName('search_result')[0].scrollTo(0, 0)
      },
      async submit () {
        this.employeeSelected = null
        const loading = this.$loading.show()
        this.$router.replace({query: {search: this.search}})
        const params = {search: this.search}
        try {
          const instRes = await InstitutionApi.search(params)
          this.institutions = instRes.data.data
        } catch (e) {
          console.log(e)
        }
        try {
          const empRes = await InstitutionApi.employeesSearch(params)
          this.employees = empRes.data.data
        } catch (e) {
          console.log(e)
        }
        loading.hide()
      },
      handleClickCloseBtn () {
        this.$router.push({name: 'home'})
      }
    },
    mounted () {
      this.setNavigatorLinks([])
      this.setNavigatorTitle('チャット')
      this.setFineplay(false)
      this.search = this.$route.query.search
      document.getElementById('institutions_search_input').focus()
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/institutions/search.vue